import axios from 'axios';
import React from 'react'
import { Component } from 'react';
import { baseURL } from '../../../../constants/applicationConstants.js';
import { Loader } from '../../../common/loader/loader.jsx';
import SuggestedOfferJsx from './custProducts.jsx'

export default class SuggestedOffer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productData: null,
      mortgageOfferData: null,
      insuranceOfferData: null,
      bankingOfferData: null,
      realestateOfferData: null,
      isProcessing: false,
      page: 1,

    }
  }

  componentDidMount = () => {
    this.getOfferData();
  }

  getOfferData = () => {
    const customerId = localStorage.getItem("masterID") && JSON.parse(localStorage.getItem("masterID"))
    const token = localStorage.getItem("token") && JSON.parse(localStorage.getItem("token"))

    this.setState({ isProcessing: true })
    
    axios.get(`${baseURL}/customer/${customerId}/products`,{
      headers: { 'x-access-token': token }
    }).then(res => {
      this.setState({ offerData: res.data.data, isProcessing: false })
     const groupedObjects = res.data.data
      // const groupedObjects = res.data.data.reduce((result, obj) => {
      //   (result[obj.parentInstitutionCategory.replace( / /g, "" )] = result[obj.parentInstitutionCategory.replace( / /g, "" )] || []).push(obj);
      //   return result;
      // }, []);
      this.setState({ productData:groupedObjects, isProcessing: false })
    })
  }
  onPaginationButtonClick = (page) => {
    // window.scrollTo(1200,1200);
    document.querySelector(".qnanav").scrollIntoView();
    this.setState({ page: page })
}

  

  render() {
    return (
      <div>
        <SuggestedOfferJsx
          investmentOfferData={this.state.investmentOfferData}
          mortgageOfferData={this.state.mortgageOfferData}
          insuranceOfferData={this.state.insuranceOfferData}
          bankingOfferData={this.state.bankingOfferData}
          realestateOfferData={this.state.realestateOfferData}
          productData={this.state.productData}
          page={this.state.page}
          onPaginationButtonClick={this.onPaginationButtonClick}


        />
        {this.state.isProcessing && <Loader />}
      </div>
    )
  }
}